import { colorsV2 } from '../../../colors-v2';
import { BorderShadingColorDefinition } from './types';

export const ELEMENT_BORDER_SHADING = 'borderShading';

export const DEFAULT_BORDER_SHADING_COLORS = {
  yellow40: {
    color: colorsV2.yellow40,
    bgColor: colorsV2.yellow5,
    borderColor: colorsV2.yellow20,
    key: 'yellow40',
  },
  primary40: {
    color: colorsV2.primary40,
    bgColor: colorsV2.primary5,
    borderColor: colorsV2.primary20,
    key: 'primary40',
  },
  purple40: {
    color: colorsV2.purple40,
    bgColor: colorsV2.purple5,
    borderColor: colorsV2.purple20,
    key: 'purple40',
  },
  green40: {
    color: colorsV2.green40,
    bgColor: colorsV2.green5,
    borderColor: colorsV2.green20,
    key: 'green40',
  },
  blue40: {
    color: colorsV2.blue40,
    bgColor: colorsV2.blue5,
    borderColor: colorsV2.blue20,
    key: 'blue40',
  },
};

export const DEFAULT_BORDER_SHADING_COLORS_LIST: BorderShadingColorDefinition[] = [
  DEFAULT_BORDER_SHADING_COLORS.yellow40,
  DEFAULT_BORDER_SHADING_COLORS.primary40,
  DEFAULT_BORDER_SHADING_COLORS.purple40,
  DEFAULT_BORDER_SHADING_COLORS.green40,
  DEFAULT_BORDER_SHADING_COLORS.blue40,
];

export const DEFAULT_BORDER_SHADING = {
  borderShadingElement: {
    component: null,
    type: ELEMENT_BORDER_SHADING,
    rootProps: {
      className: 'slate-border-shading-element',
    },
    colors: DEFAULT_BORDER_SHADING_COLORS_LIST,
    defaultColor: DEFAULT_BORDER_SHADING_COLORS.yellow40,
  },
};
